import type { DomainDataProfile } from '../../core/data-profiles';
import { genogramHydrator } from './interop/GenogramHydrator';

export const GenogramProfile: DomainDataProfile<string, string, unknown, unknown> = {
  domainId: 'genogram',
  profileVersion: '1.0',
  diagramTypes: ['genogram'],
  nodeTypes: ['person'],
  edgeTypes: ['marriage', 'child', 'sibling'],
  vocabulary: {
    recordSingular: 'Person',
    recordPlural: 'People',
    repositoryLabel: 'Family Registry',
    hierarchyLabel: 'Parent',
    importAction: 'Import Genogram',
    diagramLabel: 'genogram',
    keyColumnHint: 'Person ID',
    commitLabel: 'Commit to Registry',
    pullLabel: 'Refresh from Registry',
  },
  fieldAliases: {
    personId: ['person_id', 'personId', 'id'],
    name: ['name', 'full_name', 'fullName'],
    sex: ['sex', 'gender'],
    deceased: ['deceased', 'is_deceased'],
    location: ['location', 'place'],
    fatherId: ['father_id', 'fatherId'],
    motherId: ['mother_id', 'motherId'],
  },
  requiredProps: ['personId', 'name'],
  recommendedProps: ['fatherId', 'motherId'],
  hierarchyConfig: {
    type: 'multi-parent',
    parentProps: ['fatherId', 'motherId'],
    edgeSubtypes: {
      fatherId: 'biological_child',
      motherId: 'biological_child',
    },
  },
  primaryShapeType: 'person',
  propsToAttrsMapping: {
    personId: 'personId',
    name: 'name',
    sex: 'sex',
    deceased: 'deceased',
    location: 'location',
  },
  relationshipPackId: 'genogram-relationships',
  hydrator: genogramHydrator,
  shapeBinding: {
    onNewEntityShape: 'prompt',
    onReadOnlySource: 'diagram-only',
  },
  relationshipMappings: [
    {
      pattern: 'entity-field',
      edgeType: 'child',
      fieldOwner: 'from',
      fieldName: 'fatherId',
      fieldValue: 'to',
      cardinality: '1:1',
    },
    {
      pattern: 'entity-field',
      edgeType: 'child',
      fieldOwner: 'from',
      fieldName: 'motherId',
      fieldValue: 'to',
      cardinality: '1:1',
    },
    {
      pattern: 'edge-table',
      edgeType: 'marriage',
      tableId: 'marriages',
      sourceField: 'spouse1',
      targetField: 'spouse2',
    },
    {
      pattern: 'edge-table',
      edgeType: 'sibling',
      tableId: 'siblings',
      sourceField: 'person1',
      targetField: 'person2',
    },
  ],
  chromeConfig: {
    hiddenTools: [],
    searchTarget: 'person',
  },
  onboardingModes: ['transcript', 'template', 'blank', 'upload'],
};
